const alarmDefs = {
    "1": "Battery Low Voltage Alarm",
    "2": "Battery End of Discharge (EOD)",
    "3": "Battery Current Software Overcurrent Alarm",
    "4": "Battery Hardware Overcurrent Alarm",
    "5": "Battery Open Circuit",
    "6": "Battery Overvoltage Alarm",
    "7": "Battery Low Capacity Rate",
    "8": "Battery Low Capacity Shutdown",
    "9": "Bypass Output Overload",
    "10": "Inverter Output Overload",
    "11": "Inverter AC Output Short Circuit",
    "12": "Inverter Hardware Overcurrent Alarm",
    "13": "Inverter DC Component High Alarm",
    "14": "Busbar Hardware Overvoltage",
    "15": "Busbar Software Overvoltage",
    "16": "Busbar Undervoltage Alarm",
    "17": "Busbar Short Circuit",
    "18": "PV (Photovoltaic) Input Overvoltage",
    "19": "PV Current Software Overcurrent",
    "20": "PV Current Hardware Overcurrent",
    "21": "PV Insulation Impedance Low",
    "22": "PV Radiator Overtemperature",
    "23": "Inverter Radiator Overtemperature",
    "24": "Transformer Overtemperature",
    "25": "AC Input Relay Short Circuit",
    "26": "Output Relay Short Circuit",
    "27": "Fan Failure",
    "28": "EEPROM (Electrically Erasable Programmable Read-Only Memory) Failure",
    "29": "SPI (Serial Peripheral Interface) Communication Failure",
    "30": "Model Setting Error",
    "31": "Busbar Soft Start Failure",
    "32": "Leakage Current Abnormality",
    "33": "CAN Communication Control Failure",
    "34": "Communication CAN Bus Failure",
    "35": "Parallel Operation Mode Setting Error",
    "36": "Parallel Operation Current Sharing Failure",
    "37": "Parallel Operation ID Conflict",
    "38": "Parallel Operation Battery Inconsistency Alarm",
    "39": "Parallel Operation AC Input Inconsistency",
    "40": "Parallel Operation Synchronization Signal Abnormality",
    "41": "Parallel Operation Firmware Incompatibility",
    "42": "Parallel Operation Cable Connection Anomaly",
    "43": "Product Serial Number Error",
    "44": "System Battery Low Voltage Shutdown",
    "45": "Abnormal Shutdown Due to Slave Chip Issues",
    "46": "Busbar Imbalance",
    "47": "External CT (Current Transformer) Host Setting Error",
    "48": "AC Input Phase Anomaly",
    "49": "BMS Communication Failure",
    "50": "BMS Abnormal Alarm",
    "51": "BMS Battery Overtemperature",
    "52": "BMS Battery Overcurrent",
    "53": "BMS Battery Overvoltage",
    "54": "BMS Battery Undervoltage",
    "55": "BMS Battery Low Temperature",
    "56": "reserve",
    "57": "reserve",
    "58": "reserve",
    "59": "reserve",
    "60": "reserve",
    "61": "reserve",
    "62": "reserve",
    "63": "reserve",
    "64": "reserve",
    "65": "Grid Voltage Overvoltage",
    "66": "Grid Voltage Undervoltage",
    "67": "Grid Frequency Overfrequency",
    "68": "Grid Frequency Underfrequency",
    "69": "Grid Voltage 10-Minute Average Overvoltage",
    "70": "Low Voltage Ride Through Exception",
    "71": "High Voltage Ride Through Exception",
    "72": "System Grounding Anomaly",
    "73": "DC Arc Detection Abnormality",
    "74": "Islanding Protection",
    "75": "Electricity Meter Communication Abnormality",
    "76": "reserve",
    "77": "reserve",
    "78": "reserve",
    "79": "reserve",
    "80": "reserve"
}


function parseAlarmData(ErrorCode1, ErrorCode2,ErrorCode3,ErrorCode4,ErrorCode5,ErrorCode6,ErrorCode7,ErrorCode8) {
    const InverterAlarms = [];
    const BatteryAlarms = []
    const cs = [ErrorCode1,ErrorCode2, ErrorCode3,ErrorCode4,ErrorCode5,ErrorCode6,ErrorCode7,ErrorCode8];
    for (let i = 0; i < cs.length; i++) {
        const c = cs[i];
        if (c == 0) {
            continue;
        }

        for (let j = 0; j < 16; j++) {
            const bit = (c >> j) & 1;
            if (bit === 1) {
                const alarmCode = i * 16 + j + 1;
                InverterAlarms.push({"Code": alarmCode, "Name": alarmDefs[alarmCode]});
                if ((alarmCode >= 1 && alarmCode <= 8) || (alarmCode >= 49 && alarmCode <= 55)) {
                    BatteryAlarms.push({"Code": alarmCode, "Name": alarmDefs[alarmCode]});
                }
            }
        }
    }

    return {InverterAlarms, BatteryAlarms};
}

export default {
    parseAlarmData,
}
